(function() {


  angular.module('iq_common').directive("iqDepartmentTree", function() {

    return {
      restrict: 'AE',
      scope: {
        data: "=*data",
        nodeclick: "=nodeclick",
        icheckclick: '=icheckclick',
        icheck: "=showicheck",
        allicheck: "=allicheck",
        toggleClick: "=togglefold"
      },
      templateUrl: './templates/common/iq_department_tree.html',
      controller: function($scope, $attrs) {
        $scope.propagation = true;
        $scope.icheck_click = function(node) {
          if ($scope.icheckclick) {
            $scope.icheckclick(node);
          }
          $scope.propagation = false;
        }
        $scope.node_click = function(node) {
          if ($scope.propagation && $scope.nodeclick) {
            $scope.nodeclick(node);
          }
          $scope.propagation = true;
        }
        $scope.toggle = function(node) {
          node.isExpanded = !node.isExpanded;
          if ($scope.toggleClick) {
            $scope.toggleClick(node);
          }
          $scope.propagation = false;
        }
      }
    }
  });
})();
